import { ChoiceGroup } from "@/components/forms/ChoiceGroup";

type Props = {
  id: string;
  label: string;
  value: unknown;
  onChange: (v: boolean | undefined) => void;
  error?: string;
  note?: string;
};

const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export function FieldYesNo({ id, label, value, onChange, error, note }: Props) {
  const v = value === true ? "yes" : value === false ? "no" : null;
  return (
    <ChoiceGroup
      id={id}
      layout="segmented"
      legend={label}
      hint={note}
      options={YES_NO}
      value={v}
      onChange={(next) => {
        if (next) onChange(next === "yes");
      }}
      error={error}
      className="sm:max-w-xs"
    />
  );
}
